export enum DischargeStatus {
  InProgress = "DIP",
  ReadyToFinalise = "RTF",
  Completed = "COM",
  Reversed = "REV"
}
